<template>
  <div id="app">
	  <div v-if="showUpdateTip" style="position:fixed;top:0;left:0;right:0;z-index:99999;background:#4dffff;color:#000;text-align:center;padding:10px 16px;font-size:14px;cursor:pointer;" @click="handleUpdate">
	    發現新版本，點擊刷新
	  </div>
	  <top v-show="!isAuthPage"></top>
    <!-- <top v-show="isMobile"></top> -->
	<!-- <toppc v-show="!isMobile"></toppc> -->
    <!-- 核心：全局布局容器 + 自动判断端 + 所有页面共用 -->
    <div :class="{'layout-container':!isMobile}" >
      <!-- 左滑菜单：手机/PC 共用，右上角汉堡打开 -->
      <left v-if="!isAuthPage" :open="showLeft" @click.stop></left>

      <!-- PC端常驻侧栏已不用；改由汉堡唤出抽屉 -->
      <!-- <leftpc v-show="!isMobile && !isAuthPage"></leftpc> -->

      <!-- 所有页面内容都在这里渲染 → 侧边栏永远在外面，全局显示 -->
      <div :class="{'main-content':!isMobile, 'main-content--centered':!isMobile}">
        <router-view></router-view>
      </div>
    </div>

    <bottom ref="bottomRef" v-show="isMobile && !isAuthPage"></bottom>
	<bottompc ref="bottomRef" v-show="!isMobile && !isAuthPage"></bottompc>
  </div>
</template>

<script>
	import left from "@/components/left.vue";
	// import leftpc from "@/components/leftpc.vue"; // PC 左侧菜单已隐藏
	import top from "@/components/top.vue";
	// import toppc from "@/components/toppc.vue";
	import bottom from "@/components/bottom.vue";
	import bottompc from "@/components/bottompc.vue";
	import Vue from 'vue';
	import "@/assets/mepay77-home/mepay77-theme.css";
	export const eventBus = new Vue()
	export default {
		name: 'App',
		components: {
			top,
			bottom,
			left,
			// leftpc,
			bottompc,
			// toppc
		},
		data() {
			return {
				showLeft:false,
				// 须在 data 阶段按视口初始化；子组件 mounted 早于 App.mounted，默认 true 会导致 PC 误挂 van-swipe 再卸载报 null.width
				isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : true,
				showUpdateTip: false,
				versionTimer: null,
			}
		},
		computed: {
			isAuthPage() {
				// 登录/注册页保留顶栏底栏，与 Mepay 风格一致
				return false
			}
		},
		created() {
		    Vue.prototype.$appData = this;
		},
		mounted() {
			this.checkDevice()
			//window.addEventListener('resize', this.checkDevice)
			this.syncLoggedInClass()
			this.$bus.$on('loginStateChanged', this.syncLoggedInClass)
			this.$bus.$on('refreshUserInfo', this.syncLoggedInClass)
			window.addEventListener('storage', this.syncLoggedInClass)

			if (!localStorage.getItem('language') || localStorage.getItem('language') === 'ft') {
				localStorage.setItem('language', 'th')
				localStorage.setItem('languageTow', 'th')
				if (this.$i18n) this.$i18n.locale = 'th'
			} else if (!localStorage.getItem('languageTow')) {
				const map = { zh: 'zh_cn', th: 'th', en: 'en' }
				localStorage.setItem('languageTow', map[localStorage.getItem('language')] || 'th')
			}
			// 6. 监听事件总线的「切换左侧栏」事件
						eventBus.$on('toggleLeft', (isShow) => {
							// 如果传了具体状态就用具体值，否则切换状态
							this.showLeft = isShow !== undefined ? isShow : !this.showLeft
							if (this.showLeft) {
								this.$bus.$emit('loginStateChanged')
							}
						})
			// 监听整个页面的双击事件
			document.addEventListener('dblclick', function(event) {
				// 阻止双击事件向上冒泡
				event.stopPropagation();
				return;
			})
			// document.addEventListener('keydown', function (event) {
			//   // 判断是否按下了回车键
			//   if (event.key === 'Enter' || event.keyCode === 13) {
			//     // 刷新当前页面
			//     window.location.reload();
			//   }
			// });
			var that = this;
			window.addEventListener('resize', function(event) {
				// 阻止双击事件向上冒泡
				that.isMobile = window.innerWidth < 768
			})

			this.checkVersion()
			this.versionTimer = setInterval(() => {
				this.checkVersion()
			}, 3  * 1000)

		},
		methods: {
			syncLoggedInClass() {
				const loggedIn = !!localStorage.getItem('token')
				document.body.classList.toggle('is-logged-in', loggedIn)
			},
			hideLeft() {
							this.showLeft = false
			},
			checkDevice() {
			      this.isMobile = window.innerWidth < 768 // 768px 是常用分界线
			    },
			checkVersion() {
				const VERSION_KEY = 'app_version'
				fetch('/version.json?_t=' + Date.now())
					.then(res => res.json())
					.then(data => {
						const remoteVersion = data.version
						const localVersion = localStorage.getItem(VERSION_KEY)
						if (!localVersion) {
							localStorage.setItem(VERSION_KEY, remoteVersion)
						} else if (localVersion !== remoteVersion) {
							this.showUpdateTip = true
						}
					})
					.catch(() => {})
			},
			handleUpdate() {
				localStorage.setItem('app_version', '')
				window.location.reload()
			},
		},
		beforeDestroy() {
					eventBus.$off('toggleLeft')
					if (this.$bus) {
						this.$bus.$off('loginStateChanged', this.syncLoggedInClass)
						this.$bus.$off('refreshUserInfo', this.syncLoggedInClass)
					}
					window.removeEventListener('storage', this.syncLoggedInClass)
					if (this.versionTimer) {
						clearInterval(this.versionTimer)
						this.versionTimer = null
					}
				}
	}
</script>
<style>
	@import '@/assets/global.css';
	@import '@/assets/plugin.css';
	@import '@/assets/style.css';
	body {
		margin: 0;
	}

	#app {
		width: 100%;
	}
	/* .bg-\[\#262626\] {
		height: 100%;
		overflow-y: auto;
		position: relative;
		width: 100%;
	} */
	/*修改弹窗样式*/
	.el-message {
	  min-width: 200px !important; /* 最小宽度 */
	  max-width: 420px !important; /* 最大宽度 */
	  line-height: 1.6 !important; /* 行高，优化多行文字显示 */
	  bottom : auto !important;
	    top: 70px !important;
	    left: 10px !important;
	    right : auto !important;
	    transform: none !important;
		background: rgb(38 38 38) !important;
		border : none !important;
		font-size:18px;
		font-weight: bold;
		
	}
	.el-message__content{
		color:#fff !important;
	}
	.el-icon-close:before {
		font-size: 12px !important;
		color:#fff !important;
		font-weight: bold;
		border: 2px solid #fff;
	    border-radius: 50%;
		padding:1px;
	}
	/*修改弹窗样式结束*/
	/*修改下拉样式*/
	.el-select {
		width: 100%;
		background-color: rgb(56 56 56 / var(--tw-bg-opacity, 1)) !important;
		border-radius: 8px !important;
	}
	.el-select .el-input__inner{
		background-color: rgb(56 56 56 / var(--tw-bg-opacity, 1)) !important;
		border:none;
		border-radius: 8px !important;
	}
	.el-select-dropdown{
		background-color: rgb(36 48 58 / var(--tw-bg-opacity, 1)) !important;
		border:none;
	}
	.el-select-dropdown__item{
		color:#fff;
	}
	.el-scrollbar__wrap {
	    overflow: auto;
	    /* height: 100%; */
	}
	.popper__arrow::after{
		border-bottom-color: #000;
	}
	.el-input__inner{
		color:#fff;
	}
	.el-input__inner::placeholder {
		color:#fff;
	}
	.el-select-dropdown__item.selected {
	    color: #fff;
	    font-weight: 700;
	}
	.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
		background-color: rgb(56 56 56 / var(--tw-bg-opacity, 1));
	}
	/*修改下拉样式结束*/
	
	/*加载中*/
	.jiazaidonghua {
		height: 100px;
		width: 100px;
		background-color: #313131;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 10px;
		z-index: 99999;
	}
	
	.jiazaidonghua img {
		height: 45px;
		width: 45px;
	}
	/*加载中*/
	
	/*菜单自适应*/
	.layout-container {
	  display: flex; /* 让侧边栏 + 内容并排 */
	  /* min-height: calc(100vh - 60px); */
	}
	.main-content {
	  flex: 1; /* 内容自动占满剩余宽度 */
	  padding: 0 30px;
	  margin-top: var(--mp-header-h-pc, 72px);
	  height: calc(100vh - var(--mp-header-h-pc, 72px));
	  overflow-y: scroll;
	  scrollbar-width: none;
	    -ms-overflow-style: none;
	}
	/* 无左侧菜单时：主内容限宽居中 */
	.main-content--centered {
	  width: 100%;
	  max-width: 1280px;
	  margin-left: auto;
	  margin-right: auto;
	  padding: 0 24px 24px;
	  box-sizing: border-box;
	}
	/* PC：页面底/两侧纯黑，与底部条一致（避免灰底透出） */
	@media (min-width: 768px) {
	  html,
	  body,
	  #app {
	    background: #000 !important;
	    background-color: #000 !important;
	  }
	  .layout-container {
	    background: #000 !important;
	  }
	}
	.main-content::-webkit-scrollbar {
	  display: none;
	}
	#main::-webkit-scrollbar {
	  display: none;
	}
	/*菜单自适应*/
	.el-dialog {
		background: rgb(38 38 38/var(--tw-bg-opacity,1));
		border-radius: 24px !important;
	}
	.el-icon-close:before {
	    font-size: 16px !important;
	}
	/* .el-dialog__headerbtn {
	    top: 10px;
	    right: 10px;
	} */
	.el-dialog--center .el-dialog__body {
	    text-align: initial;
	    /* padding: 25px 0px; */
	}
	.el-dialog__title {
	    color: #fff;
	}
	.el-dialog__headerbtn{
		z-index:9999999;
	}
	.group:hover .group-hover\:\!opacity-100 {
	    opacity: 1 !important;
	}
	.el-select input {
	  /* 让 iOS 不识别为可填充字段 */
	  autocomplete: new-password !important;
	  readonly: true !important;
	  /* 消除点击高亮 */
	  -webkit-tap-highlight-color: transparent;
	  -webkit-touch-callout: none;
	}
	
	/* 外层容器 */
	.custom-select {
	  position: relative;
	  width: 100%;
	  user-select: none;
	}
	
	/* 输入框样式（和 Element 一模一样） */
	.select-input {
	  height: 44px;
	  border-radius: 8px;
	  padding: 0 15px;
	  display: flex;
	  align-items: center;
	  justify-content: space-between;
	  background: rgb(53 53 53/var(--tw-bg-opacity, 1));
	  cursor: pointer;
	  box-sizing: border-box;
	}
	
	/* 输入框文字 */
	.select-input .text {
	  font-size: 16px;
	  color: #fff;
	}
	
	/* 箭头 */
	.select-input .arrow {
	  font-size: 12px;
	  color: #fff;
	  transition: 0.2s;
	}
	
	/* 展开时箭头旋转 */
	.custom-select.open .arrow {
	  transform: rotate(180deg);
	}
	
	/* 下拉面板 */
	.select-options {
	  position: absolute;
	  top: calc(100% + 5px);
	  left: 0;
	  right: 0;
	  background: #000;
	  border-radius: 8px;
	  max-height: 280px;
	  overflow-y: auto;
	  z-index: 999;
	}
	
	/* 选项 */
	.select-option {
	  padding: 12px 15px;
	  font-size: 16px;
	  color: #fff;
	  cursor: pointer;
	}
	
	/* 选项 hover */
	.select-option:hover {
	  background-color: rgb(56 56 56/var(--tw-bg-opacity,1));
	}
	
	/* 选中高亮 */
	.select-option.active {
	  background-color: rgb(56 56 56/var(--tw-bg-opacity,1));
	  color: #fff;
	  font-weight: 500;
	}
	/* 永久解决 dialog 页面抖动 */
	html, body {
	  overflow-x: hidden;
	  padding-right: 0 !important;
	}
	body {
	  overflow-y: scroll !important;
	}
	.el-dialog__wrapper {
	  overflow: auto !important;
	}
	.close-btn-vant {
	  position: absolute;
	  top: 10px;
	  right: 15px;
	  font-size: 20px;
	  color: #999;
	  cursor: pointer;
	  z-index: 10;
	}
	.bg-\[\#4dffff\] {
	    background-color: rgb(77 255 255 / var(--tw-bg-opacity, 1)) !important;
	    color: #000 !important;
	}
	
	@media (max-width: 768px) {
		.bg-\[\#262626\] {
			height: 100%;
			position: absolute;
			overflow-y: auto;
			overflow-x: hidden;
			width: 100%;
			/* padding-bottom: calc(50px + env(safe-area-inset-bottom));
			padding-top: calc(constant(safe-area-inset-top));
			padding-top: calc(env(safe-area-inset-top));
			padding-bottom: calc(constant(safe-area-inset-bottom) + 85px);
			padding-bottom: calc(env(safe-area-inset-bottom) + 85px);
			
			z-index: 1;
			-webkit-overflow-scrolling: touch; */
			
		}
	}
	@media (min-width:769px) {
		.bg-\[\#262626\] {
			height: 100%;
			overflow-y: auto;
			overflow-x: hidden;
			width: 100%;
			padding-bottom: calc(50px + env(safe-area-inset-bottom));
			padding-top: calc(constant(safe-area-inset-top));
			padding-top: calc(env(safe-area-inset-top));
			padding-bottom: calc(constant(safe-area-inset-bottom) + 85px);
			padding-bottom: calc(env(safe-area-inset-bottom) + 85px);
			
			z-index: 1;
			-webkit-overflow-scrolling: touch;
			
		}
	}
	
	.wrap {
	  width: 100%;
	  margin: 0 auto;
	}
	.swiper-container {
	  width: 100%;
	  height: 200px;
	  padding-bottom: 40px; /* 给小圆点留出位置 */
	}
	.img {
	  width: 100%;
	  height: 100%;
	  object-fit: cover;
	  border-radius: 6px;
	}
	.slide-img{
		height:160px;
	}
	.swiper-pagination-bullet {
		width:12px !important;
		height:12px !important;
	    background: rgb(107 114 128/var(--tw-bg-opacity,1)) !important;
	}
	.swiper-pagination-bullet-active {
	    opacity: 1;
	    background: rgb(77 255 255 / var(--tw-bg-opacity, 1)) !important;
	}
	input{
		font-size:16px !important;

	}
	input::-webkit-input-placeholder {
		font-size: 15px !important;
	}
	.fz16{
		font-size:16px;
	}
	.el-checkbox__input.is-checked+.el-checkbox__label {
	    color: #fff;
	}
	.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
	    background-color: rgb(77 255 255 / var(--tw-bg-opacity, 1)) !important;
	    border-color: #409EFF;
	}
	.el-checkbox__inner::after {
		color:#000;
	}
	.el-message__content{
		padding-right:20px !important;
	}
	.el-message__closeBtn{
		right:10px;
	}
</style>